export default __webpack_public_path__ + "static/media/fibro-consejos.b8300258.png";